<template>
  <div class="analytics-report-ontime-late">
    <div class="level">
      <h3 class="level-left">Reports (ontime vs late)</h3>
      <div class="level-right">
        <b-select name="year" v-model="year" @input="selectByYear()">
          <option
            v-for="(year, index) in yearList()"
            :value="year"
            :key="index"
          >
            {{ year }}
          </option>
        </b-select>
      </div>
    </div>

    <apexchart
      v-if="series.length > 0 && chartOptions"
      type="bar"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import analyticsSerice from "@/services/AnalyticsService";
import utitlityMixin from "@/mixins/UtilityMixin";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],
  data() {
    return {
      switchCustomerId: null,
      year: this.currentYear(),
      analyticsSerice: new analyticsSerice(),
      series: [
        {
          color: "#FF8000",
          name: "Late",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          color: "#00d1b2",
          name: "On Time",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 450,
          stacked: true,
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        xaxis: {
          type: "text",
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC"
          ]
        },
        fill: {
          opacity: 1,
          colors: ["#00d1b2", "#FF8000"]
        },
        legend: {
          position: "top",
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          onItemClick: {
            toggleDataSeries: false
          }
        },
        noData: {
          text: "Sorry, No Data for the selected",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0
        }
      }
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchReportsOnTimevsLate(this.currentYear());
  },
  methods: {
    selectByYear() {
      this.fetchReportsOnTimevsLate(this.year);
    },
    fetchReportsOnTimevsLate(year) {
      this.analyticsSerice
        .getReportTrackerOnTimeVsLate(year, this.switchCustomerId)
        .subscribe(
          response => {
            this.series = response;
            const length =
              Math.max(...response[0].data) + Math.max(...response[1].data);
            this.chartOptions = {
              chart: {
                type: "bar",
                height: 450,
                stacked: true,
                toolbar: {
                  show: true
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  borderRadius: 0
                }
              },
              yaxis: {
                min: 0,
                max: length > 0 ? length + 2 : 5,
                labels: {
                  formatter: function(val) {
                    return val.toFixed(0);
                  }
                }
              },
              xaxis: {
                type: "text",
                labels: {
                  rotate: -80,
                  rotateAlways: true
                },
                categories: [
                  "JAN",
                  "FEB",
                  "MAR",
                  "APR",
                  "MAY",
                  "JUN",
                  "JUL",
                  "AUG",
                  "SEP",
                  "OCT",
                  "NOV",
                  "DEC"
                ]
              },
              fill: {
                opacity: 1,
                colors: ["#00d1b2", "#FF8000"]
              },
              legend: {
                position: "top"
              }
            };
          },
          error => {
            console.log("error loading data");
          }
        );
    }
  }
};
</script>
